/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */

export enum sortDirectionEnum {
  ASC = 'Asc',
  DESC = 'Desc',
}
